import "react-app-polyfill/ie11";
import "array-flat-polyfill";
import "es6-array-includes-shim";
require("string.prototype.includes");
require("string.prototype.endswith");
require("string.prototype.startswith");
require("array-includes").shim();
require("array.prototype.find").shim();
require("array.prototype.findindex").shim();
require("object.entries").shim();
require("number.isinteger");
